import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { CornerDownRight } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const useSwitchCave = () => {
  const { user, refreshMe } = useAuth();
  const navigate = useNavigate();
  return async (c) => {
    if (c.id === user.cave_id) return;
    try {
      await api.post("/auth/cave/switch", { cave_id: c.id });
      sessionStorage.removeItem("cellar_inventory_filters");
      await refreshMe();
      navigate("/");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
};

export const SubCellars = ({ compact = false }) => {
  const { user } = useAuth();
  const go = useSwitchCave();
  const [family, setFamily] = useState([]);
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const bump = () => setTick((t) => t + 1);
    window.addEventListener("caves:changed", bump);
    return () => window.removeEventListener("caves:changed", bump);
  }, []);
  useEffect(() => {
    api.get("/caves/family").then((r) => setFamily(r.data)).catch(() => setFamily([]));
  }, [user.cave_id, tick]);
  if (family.length < 2) return null;
  return (
    <div className={compact ? "flex gap-2 overflow-x-auto px-4 py-2 mt-12 border-y border-[#2E252A] bg-[#110D0F]" : "mx-1 -mt-6 mb-8 space-y-0.5"} data-testid="sub-cellars">
      {family.map((c) => (
        <button key={c.id} onClick={() => go(c)} data-testid={`sub-cellar-${c.id}`}
          className={`flex items-center gap-1.5 rounded-md px-2 py-1.5 text-xs whitespace-nowrap transition-colors ${c.id === user.cave_id ? "text-[#D4AF37] bg-[#D4AF37]/10" : "text-[#A89F91] hover:text-[#F5F0EB]"} ${compact ? "" : "w-full text-left"}`}>
          {c.parent_id && <CornerDownRight className="w-3 h-3 shrink-0" />}
          <span className="truncate flex-1">{c.name}</span>
          <span className="font-mono text-[10px] text-[#6E665D]">{c.bottles}</span>
        </button>
      ))}
    </div>
  );
};
